import React from 'react'
import Sidebar from '../components/mainpage/subcomponent/Sidebar'
import '../components/styles/dashboard.css'
import NotificationSettings from '../components/mainpage/subcomponent/Notification'
const MainNotification = () => {
    return (
        <div>
            <Sidebar/>
            <div className='container-fluid'>
                <NotificationSettings />
            </div>
        </div>

    )
}

export default MainNotification